/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["section[_ngcontent-%COMP%]{width:100%;height:100%;position:fixed;z-index:4000}#overlay[_ngcontent-%COMP%]{width:100vw;height:100%;background:rgba(0,0,0,.62);display:flex;align-items:center;justify-content:center}#overlay[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:100%;width:100%;position:fixed;top:-100%;bottom:-100%;left:-100%;right:-100%;margin:auto}#overlay[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{font-size:18px;color:#fff}"];
export { styles as styles };

